import {
  IAddStellaInspectionNote,
  IStellaInspectionNoteProperties,
  IUpdateInspectionStellaNote,
} from "mobx-stores/_models/inspection-note/stella-inspection-note/stella-inspection-note";
import { BaseBussiness } from "../../base";

class StellaInspectionNoteBusiness extends BaseBussiness<
  IStellaInspectionNoteProperties,
  IAddStellaInspectionNote,
  IUpdateInspectionStellaNote,
  IStellaInspectionNoteProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const stellaInspectionNoteBusiness = new StellaInspectionNoteBusiness(
  "/api/app/inspection-note-stella"
);
